import { createApi } from '@reduxjs/toolkit/query/react'

import { baseQuery } from '@/redux/utils'

interface UploadUrlResponse {
  uploadUrl: string
  accessUrl: string
}

export const fileSlice = createApi({
  reducerPath: 'file',
  baseQuery,
  endpoints: builder => ({
    upload: builder.mutation<string, File>({
      queryFn: async (file, queryApi, extraOptions, query) => {
        const result = await query({
          method: 'POST',
          url: '/upload-url',
          body: {
            filename: file.name,
          },
        })
        if (result.error) return result
        const { uploadUrl, accessUrl } = result.data as UploadUrlResponse
        const response = await fetch(uploadUrl, {
          method: 'PUT',
          body: file,
          headers: {
            'Content-Type': file.type,
          },
        })
        if (!response.ok) {
          return { error: { status: response.status, statusText: response.statusText, data: 'Upload to aws failed.' }  }
        }
        return { data: accessUrl }
      },
    }),
  }),
})

export const {
  useUploadMutation,
} = fileSlice
